import __request__ from "routing/request";
export function fieldValues(JSONbody, searchId, requestOptions) {
  return __request__("POST", `/plugins/org.graylog.plugins.enterprise/fieldvalues/${searchId}`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
